export interface LabelMappingItem {
  key: string
  label?: string
  description?: string
}

const COMPACT_DISPLAY_ID_INNER_LEN = 11

/** Compacts long IDs for display (e.g. UUIDs) into head-inner-tail form. */
export const compactDisplayId = (id: string): string => {
  const s = id.trim()
  if (s.length <= 18) return s
  const head = s.slice(0, 4)
  const tail = s.slice(-4)
  const midStart = Math.max(
    4,
    Math.floor((s.length - COMPACT_DISPLAY_ID_INNER_LEN) / 2)
  )
  const inner = s.slice(midStart, midStart + COMPACT_DISPLAY_ID_INNER_LEN)
  return `${head}-${inner}-${tail}`
}

export const getLabelFromMapping = (
  mappingArray: Array<{ key: string; label?: unknown }>,
  key: string | null
): string => {
  const label = mappingArray.find(item => item.key === key)?.label
  return typeof label === 'string' ? label : ''
}

export const getDescriptionFromMapping = (
  mappingArray: LabelMappingItem[],
  key: string | null
) => mappingArray.find(item => item.key === key)?.description ?? ''

export const getRandom = () => Math.random()
